import { Observable } from 'rxjs';

import { LocalStorageKeys } from 'v2/modules/shared/interfaces/localstorage.interface';

import { AbstractDataStore } from './abstract.data-store';
import { IState, IStorageDataStoreService, StateData } from './data-store.types';

//

export abstract class AbstractStorageDataStore<
    D extends StateData,
    S extends IState<D>,
  >
  extends AbstractDataStore<D, S>
  implements IStorageDataStoreService<D, S>
{
  abstract readonly state :S;
  abstract readonly state$ :Observable<D>;

  abstract readonly storageKey :LocalStorageKeys;

  abstract readFromStorage() :Partial<D>;
  abstract writeToStorage() :void;

  #isStoring = true;

  constructor() {
    super();
  }
  init() {
    super.init();
    this.updateState(this.readFromStorage());
  }

  isStoring() :boolean {
    return this.#isStoring;
  }

  pauseStoring() :void {
    this.toggleStoring(false);
  }
  resumeStoring() :void {
    this.toggleStoring(true);
  }
  toggleStoring(toState ?:boolean) :void {
    toState ??= !this.#isStoring;

    if (this.#isStoring !== toState) {
      this.#isStoring = toState;
    }
  }

  updateState(updates :Partial<D>) :void {
    super.updateState(updates);

    if (this.isStoring()) {
      this.writeToStorage();
    }
  }
}
